export default __webpack_public_path__ + "static/media/im-img.fc9db479.webp";